module.exports = __webpack_public_path__ + "img/ic_verify_success.5d1ee4a3.svg";